import { useState } from "react";
import { createArtist } from "@/services/api";
import {
  Box,
  TextField,
  Button,
  Container,
  Stack,
  Typography,
  Alert,
  Snackbar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NewArtist() {
  const navigate = useNavigate();
  const [key, setKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [keyError, setKeyError] = useState("");

  const validateForm = () => {
    setKeyError("");
    setError("");

    if (!key.trim()) {
      setKeyError("Username is required");
      return false;
    }

    if (key.trim().length < 2) {
      setKeyError("Username must be at least 2 characters");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await createArtist(key.trim());
      console.log(response);

      // Check if the response indicates success
      if (response && response.error) {
        throw new Error(response.error);
      }

      setSuccess(true);

      // Navigate after a short delay to show success message
      setTimeout(() => {
        navigate("/accounts");
      }, 1500);
    } catch (err) {
      console.error("Error creating artist:", err);

      let errorMessage = "Failed to create artist. Please try again.";

      if (err.message === "You are not authorized to create an artist") {
        errorMessage = "You are not authorized to create an artist.";
      } else if (err.message.includes("fetch")) {
        errorMessage = "Failed to create artist. Please try again.";
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseError = () => {
    setError("");
  };

  const handleCloseSuccess = () => {
    setSuccess(false);
  };

  return (
    <Container maxWidth="sm">
      <Stack spacing={2}>
        <Typography variant="h6">Create New Artist</Typography>

        {error && (
          <Alert severity="error" onClose={handleCloseError}>
            {error}
          </Alert>
        )}

        <TextField
          label="Username"
          value={key}
          onChange={(e) => {
            const sanitized = e.target.value
              .toLowerCase()
              .replace(/[\s.]/g, "");
            setKey(sanitized);
            if (keyError) setKeyError(""); // Clear error on change
          }}
          error={!!keyError}
          helperText={keyError}
          disabled={loading}
          required
        />

        <Button
          onClick={handleSubmit}
          variant="contained"
          fullWidth
          disabled={loading || !key.trim()}
          loading={loading}
        >
          {loading ? "Creating..." : "Create Artist"}
        </Button>
      </Stack>

      <Snackbar
        open={success}
        autoHideDuration={1500}
        onClose={handleCloseSuccess}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSuccess} severity="success">
          Artist created successfully! Redirecting...
        </Alert>
      </Snackbar>
    </Container>
  );
}
